import { render, staticRenderFns } from "./table.vue?vue&type=template&id=18784f53&scoped=true&"
import script from "./table.vue?vue&type=script&lang=js&"
export * from "./table.vue?vue&type=script&lang=js&"
import style0 from "./table.vue?vue&type=style&index=0&id=18784f53&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18784f53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18784f53')) {
      api.createRecord('18784f53', component.options)
    } else {
      api.reload('18784f53', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=18784f53&scoped=true&", function () {
      api.rerender('18784f53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/process/components/copy_handle/table/table.vue"
export default component.exports